import React from 'react'
import './footer.css';


function Footer() {
  return (
    <div className='fbody'>
      <div class="newsletter">
   <h1>
    Join Our Newsletter
   </h1>
   <input placeholder="Your Email" type="email"/>
   <button style={{margin:10}}>
    Subscribe Now
   </button>
  </div>
  <div class="footer">
   <div class="container">
    <div class="column">
     <img alt="Farmor logo" src="icons/Group.png" width="100"/>
     <p>
      Sadapoorna is a trusted name in the world of premium rice, committed to bringing the finest quality grains from farm to table. Rooted in tradition and driven by a passion for purity, Sadapoorna specializes in offering naturally grown, carefully processed rice that retains its rich aroma, nutritional value, and authentic taste.
     </p>
     <div class="social-icons">
      <a href="#">
       <i class="fab fa-facebook-f">
       </i>
      </a>
      <a href="#">
       <i class="fab fa-twitter">
       </i>
      </a>
      <a href="#">
       <i class="fab fa-instagram">
       </i>
      </a>
      <a href="#">
       <i class="fab fa-pinterest">
       </i>
      </a>
     </div>
    </div>
    <div class="column">
     <h3>
      Links
     </h3>
     <ul>
      <li>
       <a href="/privacy.html">
        Privacy Policy
       </a>
      </li>
      <li>
       <a href="/terms.html">
        Terms and Condition
       </a>
      </li>
      
      
     </ul>
    </div>
    
    <div class="column gallery">
     <h3>
      Gallery
     </h3>
     <img alt="Image of wheat field" height="70" src="https://www.caritasindia.org/wp-content/uploads/2019/02/1.jpg" width="70"/>
     <img alt="Image of fresh berries" height="70" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRO4hyEdPryusijWqm-PrAQDUqrZh3_CgG8A&s" width="70"/>
     <img alt="Image of fresh lettuce" height="70" src="https://i0.wp.com/blog.bijak.in/wp-content/uploads/2022/11/6.jpg?resize=940%2C535&ssl=1" width="70"/>
     <img alt="Image of corn field" height="70" src="https://admin.spmesmandal.org/uploads/project/656ffbd9708a8.jpg" width="70"/>
     <img alt="Image of orchard" height="70" src="https://agriculturepost.com/wp-content/uploads/2022/03/Every-block-in-India-to-have-one-farmer-producer-organisation-MoS-Agriculture-650x400.jpg" width="70"/>
     <img alt="Image of cabbage" height="70" src="https://imengine.public.prod.pdh.navigacloud.com/?uuid=235AEAF6-15C5-4141-9BB7-1622DC070F23&type=preview&function=cover&height=609&width=800" width="70"/>
     <img alt="Image of fresh vegetables" height="70" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1Vi_8blIShd5FkuOKDxtXjitUfTyrY67gtw&s" width="70"/>
     <img alt="Image of wheat" height="70" src="https://tci.cornell.edu/wp-content/uploads/2021/07/IMG_6762.jpg" width="70"/>
    </div>
   </div>
   <div class="copyright">
    Copyright 2025 @SADAPOORNA TRADERS. All Rights Reserved.
   </div>
   {/* <div class="copyright">
    Designed By -
    <a className='Company' style={{textDecoration:"none",color:"#9b9191d9"}} href='https://duniyape.in/'> Duniyape.in</a>
   </div> */}
  </div>
 
    </div>
  )
}

export default Footer
